/**
 * Created by Administrator on 2017/4/5 0005.
 */
{
    angular.module('interfaceModule')
        .controller('OrderDetailController',OrderDetailController);
    OrderDetailController.$inject = ['$scope',"$state","$stateParams",'utils.constant','utils.currentUser',
    'request.order','utils.common'];
    function OrderDetailController($scope,$state,$stateParams,constant, currentUser,
        orderRequest,common) {
    	let vm=this;
        let collect={
            'activate':activate,
            'docInfo':null,
            'printInfo':null,
            'orderInfo':null,
            'gotoPreview':gotoPreview,
            'gotoPay':gotoPay,
            'gotoSettings':gotoSettings,
            'gotoRefund':gotoRefund,
            'goToChangeOrders':goToChangeOrders,
            'gotoRefundDetail':gotoRefundDetail,
            'cancelOrderConfirm':cancelOrderConfirm,
            'parterUser':true,
            'userInfo':null,
            'userId':null
        };
        vm.collect=collect;
        activate();

        function activate(){
        	console.log($stateParams);
            getOrderInfo();
        }

        function setCover(docId,pageNum){

            let path=constant.config.sitePath+constant.config.previewPath+"/";

            if (collect.docInfo.fileName.toLowerCase().endsWith(".doc") || collect.docInfo.fileName.toLowerCase().endsWith(".docx"))
            {
                collect.docInfo.coverPath=path+"file_type_word.png";
            }
            else if (collect.docInfo.fileName.toLowerCase().endsWith(".ppt") || collect.docInfo.fileName.toLowerCase().endsWith(".pptx"))
            {
                collect.docInfo.coverPath=path+"file_type_ppt.png";
            }
            else if (collect.docInfo.fileName.toLowerCase().endsWith(".pdf"))
            {
                collect.docInfo.coverPath=path+"file_type_pdf.png";
            }
            else {
                collect.docInfo.coverPath=path+"file_type_image.png";
            }
        }

        function getOrderInfo(){
            // common.loading.show();
            orderRequest.getOrderInfo($stateParams.orderId)
            .then(function(data){
                // console.log(data);
                console.log("返回的订单：",data);
                collect.docInfo=data.docInfo;
                collect.printInfo=data.printInfo;
                collect.orderInfo=data.orderInfo;

                setCover(collect.docInfo.docId,collect.docInfo.pageNum);
                if(collect.orderInfo.status==5){
                    orderRequest.getPrintQrcode($stateParams.orderId)
                    .then(function(data){
                        // console.log(data);
                        collect.orderInfo.qrcode=data.qrcode;
                    })
                }
                
            })
        }

        function gotoPay(){
            $state.go('main.pay',{'orderId':collect.orderInfo.orderId});
        }
        function gotoPreview(){
            $state.go('main.preview',{'orderId':collect.orderInfo.orderId});
        }
        function gotoSettings(){
            $state.go('main.printSettings',{'orderId':collect.orderInfo.orderId,'canprintagain':collect.orderInfo.canprintagain});

            // 为什么传给后台的是原来的 订单号orderid ， 这样做后订单管理模快的已打印里面就没有了这个订单号。
        }
        function goToChangeOrders() {
            $state.go('main.printSettings',{'orderId':collect.orderInfo.orderId});
        }

        function gotoRefund(){
            $state.go('main.refund',{'orderId':collect.orderInfo.orderId});
        }
        function gotoRefundDetail(){
            $state.go('main.refundDetail',{'orderId':collect.orderInfo.orderId});
        }

        function cancelOrderConfirm(){
            let alert=common.alert('删除订单',
                '您确定删除订单么？',
                [{
                    'title':'取消',
                    'action':function(){
                        alert.close();
                    }
                },{
                    'title':'删除',
                    'action':function(){
                        alert.close();
                        cancelOrder()
                    }
                }]);
        }


        function cancelOrder(){
            common.loading.show();
            orderRequest.cancelOrder(collect.orderInfo.orderPrintId)
            .then(function(data){
                common.loading.hide();
                if(data.result==1){
                    common.prompt('删除订单成功');
                    $state.go("main.order");
                }else{
                    common.prompt('删除订单失败');
                }
            });

        }
    }

}